var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",class:_vm.css},[_c('field-title',{attrs:{"field":_vm.parsedField}}),_c('data-field',{attrs:{"field":_vm.parsedField,"row":_vm.data,"delayed":_vm.delayed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }